/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Control: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      d='M18 13C18.5523 13 19 13.4477 19 14V16H21C21.5523 16 22 16.4477 22 17C22 17.5523 21.5523 18 21 18H19V20C19 20.5523 18.5523 21 18 21C17.4477 21 17 20.5523 17 20V14C17 13.4477 17.4477 13 18 13ZM14.5 16C15.0523 16 15.5 16.4477 15.5 17C15.5 17.5523 15.0523 18 14.5 18H3C2.44772 18 2 17.5523 2 17C2 16.4477 2.44772 16 3 16H14.5ZM10 3C10.5523 3 11 3.44772 11 4V6H21C21.5523 6 22 6.44772 22 7C22 7.55228 21.5523 8 21 8H11V10C11 10.5523 10.5523 11 10 11C9.44772 11 9 10.5523 9 10V4C9 3.44772 9.44772 3 10 3ZM6.5 6C7.05228 6 7.5 6.44772 7.5 7C7.5 7.55228 7.05228 8 6.5 8H3L2.89746 7.99512C2.39333 7.94379 2 7.51768 2 7C2 6.48232 2.39333 6.05621 2.89746 6.00488L3 6H6.5Z'
      fill='currentColor'
    />
  </React.Fragment>
)
